// @vue/component
export default {
  name: 'ReportsFormExport',
  props: {
    report: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      formFields: {},
      fieldsTypes: {
        text: () => import(/* webpackChunkName: "report-text-field" */ './ReportsFormExportItem/ReportsFormExportItemText'),
        agent: () => import(/* webpackChunkName: "report-agent-field" */ './ReportsFormExportItem/ReportsFormExportItemAgent'),
        number: () => import(/* webpackChunkName: "report-number-field" */ './ReportsFormExportItem/ReportsFormExportItemNumber'),
        project: () => import(/* webpackChunkName: "report-project-field" */ './ReportsFormExportItem/ReportsFormExportItemProject'),
        checkbox: () => import(/* webpackChunkName: "report-checkbox-field" */ './ReportsFormExportItem/ReportsFormExportItemCheckbox'),
        datepicker: () => import(/* webpackChunkName: "report-datepicker-field" */ './ReportsFormExportItem/ReportsFormExportItemDatepicker'),
        datepickertime: () => import(/* webpackChunkName: "report-datepickertime-field" */ './ReportsFormExportItem/ReportsFormExportItemDatepickerTime'),
        daterange: () => import(/* webpackChunkName: "report-daterange-field" */ './ReportsFormExportItem/ReportsFormExportItemDaterange'),
        campaign: () => import(/* webpackChunkName: "report-agent-field" */ './ReportsFormExportItem/ReportsFormExportItemCampaign'),
      },
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'report/getDetails',
        'report/exportReport',
      ]);
    },
    getReportExportFields() {
      return this.__assignDatarangeFieldToProperty(this.$store.getters['report/details'].record.fields);
    },
    isFieldEmpty() {
      this.__setFieldsForFormExport();
      return this.$store.getters['report/details'].record.fields;
    },
  },

  created() {
    this.$store.dispatch('report/getDetails', this.report);
  },

  methods: {
    setFieldValue(value, field) {
      if (field.type_field === 'daterange') {
        this.formFields[field.uuid] = value[0];
        this.formFields[field.dependent_field_details.uuid] = value[1];
      } else {
        this.formFields[field.uuid] = value;
      }
    },
    handleCancelExportReport() {
      this.$refs.formExportReport.resetFields();
      this.$emit('handleCancelExportReport');
    },
    handleExportReport() {
      this.$refs.formExportReport.validate(async (valid) => {
        if (valid) {
          const result = await this.$store.dispatch('report/exportReport', this.formFields);
          if (result[0] !== 'no_content') {
            this.__forceDownloadFile();
          } else {
            this.$message({
              type: 'warning',
              message: 'Raport nie zawiera żadnych rekordów',
            });
          }
          this.$emit('handleCancelExportReport');
        }
      });
    },
    __setFieldsForFormExport() {
      if (this.$store.getters['report/details'].record.fields) {
        this.$store.getters['report/details'].record.fields.forEach((field) => {
          this.$set(this.formFields, field.uuid, field.default_value);
        });
      }
    },
    __forceDownloadFile() {
      const file = this.$store.getters['report/exportFile'];
      const element = document.createElement('a');
      element.setAttribute('href', file);
      element.setAttribute('download', 'raport.csv');
      if (document.createEvent) {
        const event = document.createEvent('MouseEvents');
        event.initEvent('click', true, true);
        element.dispatchEvent(event);
      } else {
        element.click();
      }
    },
    __assignDatarangeFieldToProperty(fields) {
      let fieldsArray = fields.map(item => (fields.find(dependentItem => dependentItem.dependent_field_uuid === item.uuid)
        ? { ...item, dependent_field_details: fields.find(dependentItem => dependentItem.dependent_field_uuid === item.uuid) }
        : item));

      fieldsArray = fieldsArray.filter(item => !item.dependent_field_uuid);
      return fieldsArray;
    },
  },
};
